exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.content-wrapper[data-v-555f77f0] {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 0 5%;\n}\n.buttons-row[data-v-555f77f0] {\r\n  margin: 0 -5%;\n}\n.loader[data-v-555f77f0] {\r\n  position: fixed;\r\n  z-index: 1;\r\n  background: rgb(255, 255, 255);\n}\n.tabs-wrap[data-v-555f77f0] {\r\n  padding: 20px 0;\n}\n#widget[data-v-555f77f0]{\r\n    width: 100%;\r\n    height: 100%;\r\n    box-sizing: border-box;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-555f77f0","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/garage/garage.vue
// module id = 610
// module chunks = 0